import { PaginatedQueryDTO } from 'infrastructure/dtos/pagination/requests/PaginatedQueryDTO';
import { ApiPathConfig } from '../types';
import { CreativeResponseDTO } from 'infrastructure/dtos/creative';

export const PaginatedCreativesWithPostRequest: ApiPathConfig<
  PaginatedQueryDTO,
  {
    data: CreativeResponseDTO[];
    current_page: number;
    last_page: number;
    per_page: number;
    total: number;
  }
> = {
  method: 'GET',
  path: '/admin/instagram/posts',
  response: {
    data: [] as CreativeResponseDTO[],
    current_page: 0 as number,
    last_page: 0 as number,
    per_page: 0 as number,
    total: 0 as number,
  } as {
    data: CreativeResponseDTO[];
    current_page: number;
    last_page: number;
    per_page: number;
    total: number;
  },
  body: {} as PaginatedQueryDTO,
  buildRoute: function (dto: PaginatedQueryDTO): string {
    return `${this.path}?page=${dto.page}`;
  },
} as const;
